import React from "react";
import LawFirmBondsPage from "./components/LawFirmBondsPage";
import { LAW_FIRM_BONDS_MODES } from "./helpers/lawFirmBondsPageConfig";

const LawFirmApproveBonds = () => (
  <LawFirmBondsPage mode={LAW_FIRM_BONDS_MODES.APPROVE} />
);

export default LawFirmApproveBonds;
